import { EvaChartFeatures } from "types";

export function extractActiveAndProperties(features: Partial<EvaChartFeatures>) {
  return Object.keys(features).reduce((acc, key) => {
    const feature = features[key];
    // Skip keys the chart doesn't actually carry a feature for. UNDEFINED_CHART_FEATURES
    // declares EVERY feature key with an `undefined` value, and it is what
    // useChartEntities hands back while a chart entity has no features yet — so
    // without this the writer synthesises `{ properties: {}, active: false }` for
    // features that were never set. Two ways that bites:
    //   - a propertyless chartTypeParam reaches handleFeaturesOnChartTypeSwitch,
    //     which reads properties.x/.y directly and threw (EVA-155);
    //   - `active: false` is a real override, so a default-on feature (survivorBias,
    //     useWeightedRatioAverage) comes back off on the next chart-type switch.
    // Skipping also restores the snapshot merge's intent: keys the current chart type
    // carries win, keys it doesn't carry stay dormant rather than being overwritten
    // with placeholders.
    if (!feature) return acc;
    acc[key] = {
      properties: feature.properties || {},
      active: feature.active || false
    };
    return acc;
  }, {});
}
